<script>
import {
  memberListAgentadminComputed,
  memberListAgentadminMethods,
} from '@state/helpers/member-list-agentadmin'
import { authComputed } from '@state/helpers'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper, csvExport, addParamsToLocation } from '@utils/helpers'
import {
  GENDER,
  ROLE,
  DATE_TIME_FORMAT,
  COMMENT_LEVEL,
} from '@/src/utils/constant'
import CsvExportPopup from '@components/molecules/csv-export-popup.vue'
import formatDate from '@utils/format-date'
import split from 'lodash/split'
import { CSV_FILE_NAME } from '@utils/csvFilename'
import cloneDeep from 'lodash/cloneDeep'
import every from 'lodash/every'
import values from 'lodash/values'
import { endOfDay, startOfDay, startOfMonth } from 'date-fns'
import tableFields from './tableFields'
import { rateItem, COLOR_RATE } from './rateItem'
import searchFilter from './searchFilter'
import optionStatus from './optionsStatus'

export default {
  COMMENT_LEVEL,
  COLOR_RATE,
  components: { CsvExportPopup },
  props: {
    searchGender: {
      type: Object,
      default: () => {},
    },
    searchStatus: {
      type: Object,
      default: () => {},
    },
    searchAge: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: {},
      searchBody: new SearchPayload.Builder(),
      fields: tableFields,
      GENDER: GENDER,
      COLOR_RATE: COLOR_RATE,
      rateItem: rateItem,
      searchFilter: cloneDeep(searchFilter),
      showSearch: false,
      showDropdown: false,
      optionStatus: optionStatus,
      optionChangeStatus: [
        {
          label: ' ',
          value: '0',
        },
        {
          label: '',
          value: '1',
        },
        {
          label: '',
          value: '2',
        },
        {
          label: '',
          value: '3',
        },
        {
          label: '',
          value: '4',
        },
        {
          label: '',
          value: '5',
        },
        {
          label: '',
          value: '6',
        },
        {
          label: '',
          value: '7',
        },
        {
          label: '',
          value: '8',
        },
      ],
      memberIdSelected: {},
      openConfirm: false,
      statusIndex: '0',
      openConfirmUnbind: false,
      filtered: false,
      componentKey: 0,
      csvKey: 0,
      role: null,
      ROLE: ROLE,
      question: [4, 1, 2, 3],
      optionQuestion: [
        {
          key: 'question1',
          content: '',
          label: '質問1',
          type: '',
          options: [],
        },
        {
          key: 'question2',
          content: '',
          label: '質問2',
          type: '',
          options: [],
        },
        {
          key: 'question3',
          content: '',
          label: '質問3',
          type: '',
          options: [],
        },
        {
          key: 'question4',
          content: '',
          label: '質問4',
          type: '',
          options: [],
        },
      ],
    }
  },
  computed: {
    ...memberListAgentadminComputed,
    ...authComputed,
    memberListAgentData() {
      return this.getMemberListAgent?.list || []
    },
    paginationComputed() {
      let paginations = {}
      if (this.getMemberListAgent) {
        paginations = ObjectHelper.removePropertyByKey('list')(
          this.getMemberListAgent
        )
      }
      return paginations
    },
    checklevelCurrentUser() {
      return this.getCurrentUser?.level <= ROLE.AGENT_SUB
    },
    unselectedAll() {
      return every(values(this.memberIdSelected), function(v) {
        return !v
      })
    },
    confirmComputed() {
      if (this.unselectedAll) {
        return 'unselected'
      }
      return 'member_status_apply'
    },
    confirmUnbindComputed() {
      if (this.unselectedAll) {
        return 'unselected'
      }
      return 'quitagent'
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
    },
    searchGender() {
      const order = { order_by: this.searchBody.order_by }
      this.searchFilter = cloneDeep(searchFilter)
      this.searchBody = new SearchPayload.Builder()
      this.searchBody = { ...this.searchBody, ...order }
      this.searchBody = { ...this.searchBody, ...this.searchGender }
      this.fetchingMemberListAgent(this.searchBody)
      this.filtered = true
    },
    searchStatus() {
      const order = { order_by: this.searchBody.order_by }
      this.searchFilter = cloneDeep(searchFilter)
      this.searchBody = new SearchPayload.Builder()
      this.searchBody = { ...this.searchBody, ...order }
      this.searchBody = { ...this.searchBody, ...this.searchStatus }
      this.fetchingMemberListAgent(this.searchBody)
      this.filtered = true
    },
    searchAge() {
      const order = { order_by: this.searchBody.order_by }
      this.searchFilter = cloneDeep(searchFilter)
      this.searchBody = new SearchPayload.Builder()
      this.searchBody = { ...this.searchBody, ...order }
      this.searchBody = { ...this.searchBody, ...this.searchAge }
      this.fetchingMemberListAgent(this.searchBody)
      this.filtered = true
    },
  },
  created() {
    this.role = this.$store.getters['auth/getCurrentUser'].level
    const filter = this.$route.query
    if (filter.page_no) {
      filter.page_no = parseInt(filter.page_no, 10)
      filter.lines = parseInt(filter.lines, 10)
      if (filter.member_status !== undefined && filter.member_status !== '') {
        filter.member_status = parseInt(filter.member_status, 10)
      }
      if (filter.gender) {
        filter.gender = parseInt(filter.gender)
      }
      for (const key in filter) {
        if (filter[key] === 'undefined') {
          filter[key] = ''
        }
        if (key !== 'page_no' && key !== 'lines') {
          if (filter[key] !== '' && filter[key] !== undefined) {
            this.searchBody = filter
            this.filtered = true
          }
        }
      }
      if (filter.page_no > 1) {
        this.searchBody = filter
      }
    }
    this.searchFilter = { ...cloneDeep(searchFilter), ...this.searchBody }
    if (this.searchFilter.member_status) {
      this.searchFilter.member_status = this.searchFilter.member_status.toString()
    }
    this.handleSearchMemberListAgent()
    this.getStatus()
  },
  methods: {
    ...memberListAgentadminMethods,
    handleSearchMemberListAgent() {
      if (this.$route.query.key) {
        if (this.$route.query.key !== 'search_unused_members') {
          this.searchBody.last_measure_at_from = formatDate(
            startOfMonth(new Date()),
            'yyyy/MM/dd'
          )
          this.searchBody.last_measure_at_to = formatDate(
            new Date(),
            'yyyy/MM/dd'
          )
        }
        this.searchBody = {
          ...this.searchBody,
          ...{ [this.$route.query.key]: parseInt(this.$route.query.value) },
        }
      }
      this.fetchingMemberListAgent({
        ...this.searchBody,
      })
      if (this.$route.query.key) {
        this.filtered = true
      }
    },
    handleSorter(key) {
      if (key === 'status_name') {
        key = 'member_status'
      }
      if (key === 'status_name-') {
        key = 'member_status-'
      }
      this.searchBody = { ...this.searchBody, order_by: key }
      this.handleSearchMemberListAgent()
    },
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchMemberListAgent()
    },
    async exportCsv(date) {
      date.date_end = formatDate(
        endOfDay(new Date(date.date_end)),
        DATE_TIME_FORMAT
      )
      date.date_start = formatDate(
        startOfDay(new Date(date.date_start)),
        DATE_TIME_FORMAT
      )
      const response = await this.exportMemberListAgentCsv({
        ...this.searchBody,
        ...date,
      })

      csvExport(response, CSV_FILE_NAME.memberListAgent)
      this.csvKey++
    },
    handleChangeRangeData(lower, upper, value) {
      this.searchFilter[lower] = value.left
      this.searchFilter[upper] = value.right
    },
    async searchMemberListAgent() {
      this.searchFilter.member_status = parseInt(
        this.searchFilter.member_status,
        10
      )

      const dateArr = [
        'created_at_to',
        'created_at_from',
        'last_measure_at_from',
        'last_measure_at_to',
      ]

      dateArr.forEach((item) => {
        if (this.searchFilter[item]) {
          this.searchFilter[item] = formatDate(
            this.searchFilter[item],
            'yyyy/MM/dd'
          )
        }
      })
      this.searchBody = { ...this.searchBody, ...this.searchFilter }
      this.fetchingMemberListAgent(this.searchBody)
      this.searchFilter.member_status = this.searchFilter.member_status.toString()
      this.showSearch = false
      this.filtered = true
    },
    clearSearch() {
      this.componentKey++
      const order = { order_by: this.searchBody.order_by }
      this.searchFilter = cloneDeep(searchFilter)
      this.searchBody = new SearchPayload.Builder()
      this.searchBody = { ...this.searchBody, ...order }
      this.fetchingMemberListAgent(this.searchBody)
      this.showSearch = false
      this.filtered = false
      const user = this.$store.getters['auth/getCurrentUser']
      this.$router.replace({ query: { agent_code: user?.agent?.agent_code } })
    },
    handleSelected(id, value) {
      const temp = { ...this.memberIdSelected }
      temp[id] = value
      this.memberIdSelected = { ...temp }
    },
    changeStatus() {
      const data = []
      for (const id in this.memberIdSelected) {
        if (this.memberIdSelected[id]) {
          data.push({
            member_id: parseInt(id, 10),
            status_index: parseInt(this.statusIndex, 10),
          })
        }
      }
      this.changeStatusMember({
        data: data,
        agent_id: this.getCurrentUser?.agent.id,
      }).then(() => {
        this.statusIndex = '0'
        this.handleSearchMemberListAgent()
      })
      this.memberIdSelected = {}
      this.openConfirm = false
    },
    handleUnbindMember() {
      const temp = { ...this.memberIdSelected }
      const flag = Object.keys(temp)?.map((key) => {
        if (temp[key]) {
          return key
        }
      })
      Promise.all(
        flag?.map((id) => {
          return this.unbindMember({
            member_id: parseInt(id, 10),
            agent_id: this.getCurrentUser?.agent.id,
          })
        })
      ).then(() => {
        this.openConfirmUnbind = false
        this.handleSearchMemberListAgent()
        this.memberIdSelected = {}
      })
    },
    async getStatus() {
      const response = await this.fetchingStatus({
        id: this.getCurrentUser?.agent.id,
      })
      if (response) {
        this.optionQuestion = this.optionQuestion.map((element, index) => {
          element.content = response[`question${index + 1}`]
          if (response[`answer${index + 1}`] === '') {
            element.type = 'input'
          } else {
            element.type = 'select'
            const arrayAnswer = split(response[`answer${index + 1}`], ',')
            element.options = arrayAnswer.map((item) => {
              return {
                value: item,
                label: item,
              }
            })
          }
          element.options.unshift({ value: '', label: '' })
          return element
        })
        this.optionStatus = this.optionStatus.map((element, index) => {
          if (index === 0) {
            element.label = ' '
          } else if (index === 1) {
            element.label = '-'
          } else {
            element.label = response[`status${index - 1}_name`]
          }
          return element
        })
        this.optionChangeStatus = this.optionChangeStatus.map(
          (element, index) => {
            if (index === 0) {
              element.label = ' '
            } else {
              element.label = response[`status${index}_name`]
            }
            return element
          }
        )
      }
    },
    handleChangeDate(dateStart, dateEnd, value) {
      this.searchFilter[dateStart] = value.date_start
      this.searchFilter[dateEnd] = value.date_end
    },
    viewDetail(item) {
      this.$router.push({
        path: `/panel/member-list-agent-admin/${item.member_id}/${item.agent_id}`,
      })
    },
  },
}
</script>

<template>
  <div>
    <BaseCardDetail title="ユーザー覧" form-collapsed>
      <template v-slot:header-action>
        <div class="d-flex">
          <CDropdown
            v-if="role !== ROLE.AGENT_AUDIT"
            :show.sync="showDropdown"
            add-menu-classes="p-1"
            placement="bottom-end"
            add-toggler-classes="btn btn-outline-dark ml-2 pt-0 pb-0"
            toggler-text="一括変更"
          >
            <template>
              <BaseSelect
                label="ステータス変更"
                :options="optionChangeStatus"
                :value.sync="statusIndex"
              >
                <template v-slot:append>
                  <CButton
                    color="dark"
                    variant="outline"
                    @click="openConfirm = true"
                  >
                    適用
                  </CButton>
                </template>
              </BaseSelect>
              <CButton
                color="dark"
                variant="outline"
                class="w-100"
                @click="openConfirmUnbind = true"
              >
                退会
              </CButton>
            </template>
          </CDropdown>
          <CsvExportPopup :key="csvKey" @export="exportCsv">
            <template v-slot>
              <label class="py-1 mb-0">アライアンス登録日時</label>
            </template>
          </CsvExportPopup>
          <CDropdown
            :show.sync="showSearch"
            add-menu-classes="p-2 dropdown-feeline"
            placement="left-start"
            add-toggler-classes="btn btn-outline-dark ml-2 pt-0 pb-0"
          >
            <template v-slot:toggler-content>
              <font-awesome-icon icon="search" />
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <CForm
                ref="form"
                @submit.stop.prevent="handleSubmit(searchMemberListAgent)"
              >
                <CRow>
                  <CCol sm="6">
                    <BaseInput
                      v-model="searchFilter.search_name"
                      label="ユーザ名"
                    />
                    <BaseNumberInputRanger
                      main-label="体重"
                      :left="searchFilter.weight_lower"
                      :right="searchFilter.weight_upper"
                      min="0"
                      max="100"
                      :step="0.01"
                      :hide-label="true"
                      @update:value="
                        (v) =>
                          handleChangeRangeData(
                            'weight_lower',
                            'weight_upper',
                            v
                          )
                      "
                    />
                    <BaseNumberInputRanger
                      :left="searchFilter.bmi_lower"
                      :right="searchFilter.bmi_upper"
                      main-label="BMI"
                      min="0"
                      max="100"
                      :step="0.01"
                      :hide-label="true"
                      @update:value="
                        (v) =>
                          handleChangeRangeData('bmi_lower', 'bmi_upper', v)
                      "
                    />
                    <BaseNumberInputRanger
                      :left="searchFilter.body_fat_rate_lower"
                      :right="searchFilter.body_fat_rate_upper"
                      main-label="体脂肪率"
                      min="0"
                      :step="0.01"
                      max="100"
                      :hide-label="true"
                      @update:value="
                        (v) =>
                          handleChangeRangeData(
                            'body_fat_rate_lower',
                            'body_fat_rate_upper',
                            v
                          )
                      "
                    />
                    <BaseNumberInputRanger
                      :left="searchFilter.compare_weight_lower"
                      :right="searchFilter.compare_weight_upper"
                      main-label="体重変位"
                      min="-100"
                      max="100"
                      :step="0.01"
                      :hide-label="true"
                      @update:value="
                        (v) =>
                          handleChangeRangeData(
                            'compare_weight_lower',
                            'compare_weight_upper',
                            v
                          )
                      "
                    />
                    <BaseNumberInputRanger
                      :left="searchFilter.compare_BodyFatRate_lower"
                      :right="searchFilter.compare_BodyFatRate_upper"
                      main-label="体脂肪変位"
                      min="-100"
                      max="100"
                      :step="0.01"
                      :hide-label="true"
                      @update:value="
                        (v) =>
                          handleChangeRangeData(
                            'compare_BodyFatRate_lower',
                            'compare_BodyFatRate_upper',
                            v
                          )
                      "
                    />
                    <BaseDateRangerPicker
                      :key="componentKey"
                      picker-type="datetime"
                      main-label="アライアンス登録日"
                      :start-date="searchFilter.created_at_from"
                      :end-date="searchFilter.created_at_to"
                      @update:value="
                        (v) =>
                          handleChangeDate(
                            'created_at_from',
                            'created_at_to',
                            v
                          )
                      "
                    />
                  </CCol>
                  <CCol sm="6">
                    <BaseInput v-model="searchFilter.admin_note" label="備考" />
                    <BaseSelect
                      label="ステータス"
                      :options="optionStatus"
                      :value.sync="searchFilter.member_status"
                    />
                    <template v-for="(item, index) in optionQuestion">
                      <BaseInput
                        v-if="item.type === 'input' && item.content !== ''"
                        :key="item.key"
                        v-model="searchFilter[`member_answer${index + 1}`]"
                        :label="item.label"
                      />
                      <BaseSelect
                        v-if="item.type === 'select' && item.content !== ''"
                        :key="item.key"
                        :label="item.label"
                        :options="item.options"
                        :value.sync="searchFilter[`member_answer${index + 1}`]"
                      />
                    </template>
                    <BaseDateRangerPicker
                      :key="componentKey"
                      picker-type="datetime"
                      :start-date="searchFilter.last_measure_at_from"
                      :end-date="searchFilter.last_measure_at_to"
                      main-label="最終計測日"
                      @update:value="
                        (v) =>
                          handleChangeDate(
                            'last_measure_at_from',
                            'last_measure_at_to',
                            v
                          )
                      "
                    />
                  </CCol>
                </CRow>
                <div class="d-flex">
                  <CButton color="primary" type="submit" class="w-50">
                    検索
                  </CButton>
                  <CButton color="light" class="ml-2 w-50" @click="clearSearch">
                    クリア
                  </CButton>
                </div>
              </CForm>
            </validation-observer>
          </CDropdown>
        </div>
      </template>
      <BasePagination
        :paginations="paginationComputed"
        :searching="filtered"
        @activePagination="handlePagination"
      />
      <BaseTable
        hover
        striped
        border
        :table-fields="fields"
        :data-tables="memberListAgentData"
        @sorterBy="handleSorter"
        @row-clicked="(item) => viewDetail(item)"
      >
        <template v-slot:id="{ item }">
          <td class="py-2" @click.stop="() => {}">
            <CInputCheckbox
              v-if="checklevelCurrentUser && item.master_member_id"
              :checked="memberIdSelected[item.member_id]"
              color="primary"
              @update:checked="(v) => handleSelected(item.member_id, v)"
            />
          </td>
        </template>
        <template v-slot:photo="{ item }">
          <td>
            <CImg
              v-if="item.photo"
              shape="rounded-circle"
              height="40px"
              width="40px"
              :src="item.photo"
            />
            <CImg
              v-else-if="item.gender === GENDER[0]"
              shape="rounded-circle"
              height="40px"
              width="40px"
              :src="require('@assets/images/female.png')"
            />
            <CImg
              v-else
              shape="rounded-circle"
              height="40px"
              width="40px"
              :src="require('@assets/images/male.png')"
            />
          </td>
        </template>
        <template v-slot:admin_note="{ item }">
          <td>
            <div class="feelline-limit-line">
              {{ item.admin_note }}
            </div>
          </td>
        </template>
      </BaseTable>
    </BaseCardDetail>
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirm"
      :type="confirmComputed"
      :hide-action-button="unselectedAll"
      @closeModal="openConfirm = !openConfirm"
      @submit="changeStatus"
    />
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirmUnbind"
      :type="confirmUnbindComputed"
      :hide-action-button="unselectedAll"
      @closeModal="openConfirmUnbind = !openConfirmUnbind"
      @submit="handleUnbindMember"
    />
  </div>
</template>

<style lang="scss" scoped>
::v-deep .feelline-limit-line {
  display: -webkit-box;
  max-height: 6.2rem;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
}
::v-deep .dropdown-feeline {
  min-width: 32rem !important;
}
::v-deep .dropdown-menu {
  min-width: 200px;
}
</style>
